<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="form"
            :inline="true"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            label-width="80px"
            style="padding: 10px 0 0 100px"
        >
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable>
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="listData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            files: [],
            dateArr: [],
            query: {
                state: "US",
            },
            us_arr: [
                {
                    us: 'US',
                    title: '美国'
                },
                {
                    us: 'UK',
                    title: '英国'
                },
                {
                    us: 'DE',
                    title: '德国'
                }
            ],
            rules: {
                project_name: [
                    {
                        required: true,
                        message: "请输入项目组",
                        trigger: "blur"
                    }
                ],
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ]
            },
            listData: {}
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        state: String,
        asin: Number
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },

        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (!this.listData.dateArr.length) {
                        this.$message.warning(`请选择日期`);
                        return;
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "添加中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.sb_ad_position_analysis_add({
                        state: this.query.state,
                        start_date: this.listData.dateArr[0],
                        end_date: this.listData.dateArr[1]
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.listData.dateArr = [];
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
